import api from '@/api_alv'
import Vue from 'vue'
import i18n from '@/assets/i18n/i18n'
import { router } from '@/router.js'

const DIR = 'account/credentials'

const DEFAULT_CREDENTIALS = {
    "id": 0,
    "alvId": "ALV000000000UC",
    "firstName": null,
    "lastName": null,
    "username": null,
    "password": null,
    "apikey": null,
    "email": null,
    "interests": null,
    "role": null,
    "credentialsType": null,
    "host": null,
    "port": null,
    "ftpDirSend": null,
    "ftpDirFetch": null,
}

const state = {
    credentials: [],
    credentialsEmptyRow: {
        id: 0,
        alvId: null,
        firstName: "",
        lastName: "",
        username: "",
        password: "",
        apikey: "",
        interests: "",
        email: "",
        credentialsType: "",
        host: null,
        port: null,
        ftpDirSend: null,
        ftpDirFetch: null,
        editable: true,
    },
    credentialsNewRow: false,
    credentialsShowRoleDropdown: false,
    disableCredentialsNewRowSaveBtn: false,
    defaultCredentials: DEFAULT_CREDENTIALS,
    credentialsEditingDialogDetails: DEFAULT_CREDENTIALS,
    selectedCredentials: [], // by ID
    selectedCredentialsUser: null,
    adminInformationChanged: false,

    //Messages
    showPaymentMessage: false,
    showGemaSoundfileExistsMessage: false,
}

const getters = {
    getCredentials(state) { return state.credentials },
    getDisableCredentialsNewRowSaveBtn(state) { return state.disableCredentialsNewRowSaveBtn },
    getCredentialsNewRow(state) { return state.credentialsNewRow },
    getCredentialsShowRoleDropdown(state) { return state.credentialsShowRoleDropdown },
    getCredentialsEmptyRow(state) { return state.credentialsEmptyRow },
    getSelectedCredentials(state) { return state.selectedCredentials },
    getSelectedCredentialsUser(state) { return state.selectedCredentialsUser },
    getDefaultCredentials(state) { return state.defaultCredentials },
    getCredentialsEditingDialogDetails(state) { return state.credentialsEditingDialogDetails },
    getCredentialsDetailsUsername(state) { return state.credentialsEditingDialogDetails.username },
    getCredentialsDetailsFirstName(state) { return state.credentialsEditingDialogDetails.firstName },
    getCredentialsDetailsLastName(state) { return state.credentialsEditingDialogDetails.lastName },
    getCredentialsDetailsPassword(state) { return state.credentialsEditingDialogDetails.password },
    getCredentialsDetailsRole(state) { return state.credentialsEditingDialogDetails.role },
    getCredentialsDetailsApiKey(state) { return state.credentialsEditingDialogDetails.apikey },
    getCredentialsDetailsInterests(state) { return state.credentialsEditingDialogDetails.interests },
    getCredentialsDetailsEmail(state) { return state.credentialsEditingDialogDetails.email },

    getCredentialsDetailsCredentialsType(state) { return state.credentialsEditingDialogDetails.credentialsType },

    getCredentialsDetailsAlvId(state) { return state.credentialsEditingDialogDetails.alvId },
    getAdminInformationChanged(state) { return state.adminInformationChanged },

    //Messages
    getShowPaymentMessage(state) { return state.showPaymentMessage },
    getShowGemaSoundfileExistsMessage(state) { return state.showGemaSoundfileExistsMessage },

}

const mutations = {
    setCredentials: (state, credentialsFromDB) => { state.credentials = credentialsFromDB },
    setCredentialsNewRow: (state, status) => { state.credentialsNewRow = status },
    setDisableCredentialsNewRowSaveBtn: (state, status) => { state.disableCredentialsNewRowSaveBtn = status },
    setShowPaymentMessage: (state, show) => { state.showPaymentMessage = show },
    setShowGemaSoundfileExistsMessage: (state, show) => { state.showGemaSoundfileExistsMessage = show },
    setCredentialsShowRoleDropdown: (state, status) => { state.credentialsShowRoleDropdown = status },
    setDefaultCredentials: (state) => { state.defaultCredentials = DEFAULT_CREDENTIALS },
    setCredentialsEditingDialogDetails: (state, details) => { state.credentialsEditingDialogDetails = details },
    setCredentialsDetailsUsername: (state, username) => { state.credentialsEditingDialogDetails.username = username },
    setCredentialsDetailsFirstName: (state, firstName) => { state.credentialsEditingDialogDetails.firstName = firstName },
    setCredentialsDetailsLastName: (state, lastName) => { state.credentialsEditingDialogDetails.lastName = lastName },
    setCredentialsDetailsPassword: (state, password) => { state.credentialsEditingDialogDetails.password = password },
    setCredentialsDetailsRole: (state, role) => { state.credentialsEditingDialogDetails.role = role },
    setCredentialsDetailsApiKey: (state, apikey) => { state.credentialsEditingDialogDetails.apikey = apikey },
    setCredentialsDetailsInterests: (state, interests) => { state.credentialsEditingDialogDetails.interests = interests },
    setCredentialsDetailsEmail: (state, email) => { state.credentialsEditingDialogDetails.email = email },

    setCredentialsDetailsCredentialsType: (state, value) => { state.credentialsEditingDialogDetails.credentialsType = value },

    setCredentialsDetailsAlvId: (state, alvId) => { state.credentialsEditingDialogDetails.alvId = alvId },
    setAdminInformationChanged: (state, change) => { state.adminInformationChanged = change },
    setShowAutoLogoutConfirmationDialog: (state, context) => { state.showAutoLogoutConfirmationDialog = context },

    setCredentialTempRow: (state, row) => {
        let index = state.credentials.findIndex(cred => cred.id == row.id)
        let oldValues = JSON.parse(JSON.stringify(row));
        state.credentials[index]["oldValues"] = oldValues;
    },
    deleteCredentialTempRow: (state, row) => {
        let index = state.credentials.findIndex(cred => cred.id == row.id)
        delete state.credentials[index]["oldValues"];
    },
    replaceNewValuesWithOld: (state, row) => {
        let index = state.credentials.findIndex(cred => cred.id == row.id)
        let oldValues = JSON.parse(JSON.stringify(state.credentials[index]["oldValues"]));
        Vue.set(state.credentials, index, oldValues);
    },
    deleteRow: (state, row) => {
        let index = state.credentials.findIndex(cred => cred.id == row.id);
        Vue.delete(state.credentials, index);
    },
    setSelectedCredentials: (state, id) => { state.selectedCredentials = id },
    setSelectedCredentialsUser: (state, user) => { state.selectedCredentialsUser = user },
}

const actions = {
    async fetchCredentials({ commit, getters }) {
        let response = await api.getListData(
            DIR
        )
        let arr = response
        // let credentialsType = getters.getAccountCredentialsType
        arr.forEach((element, index) => {
            element['passwordHidden'] = '\u2022'.repeat(element.password.length);
            element['editable'] = false
            // element['id'] = index + 1
            // let type = credentialsType.find((e) => e.value == element.type.value)
            // element['type'] = type
        });
        commit('setCredentials', arr);
        this._vm.$alvPlugin.storePagingInformations(response.filteredRecords, response.currentPage, response.totalRecords)
        commit('setIsLoading', false);
    },
    addNewRowCredentials({ commit, getters }) {
        let arr = getters.getCredentials
        let newRow = JSON.parse(JSON.stringify(getters.getCredentialsEmptyRow))
        newRow.id = -(1000 + Math.floor(Math.random() * 123));
        arr.unshift(newRow)
        commit('setCredentials', arr);
    },
    async saveCredentialsRow({ commit, getters, dispatch }) {
        let metaData = {
            "username": getters.getCredentialsDetailsUsername,
            "firstName": getters.getCredentialsDetailsFirstName,
            "lastName": getters.getCredentialsDetailsLastName,
            "password": getters.getCredentialsDetailsPassword,
            "role": getters.getCredentialsDetailsRole,
            "apikey": getters.getCredentialsDetailsApiKey,
            "interests": getters.getCredentialsDetailsInterests,
            "email": getters.getCredentialsDetailsEmail,
            "credentialsType": getters.getCredentialsDetailsCredentialsType,
            "alvId": getters.getCredentialsDetailsAlvId
        }

        let isNew = true
        // let id = getters.getSelectedCredentials[0]
        let alvId = getters.getCredentialsDetailsAlvId

        if (getters.getSelectedCredentials.length === 0) {
            isNew = true
        } else {
            isNew = false
        }
        let response = await api.saveEditForm(DIR, alvId, metaData, isNew, '')

        if (response === undefined || response.length === 0 || response.error === 1) {
            response = []
            commit('setSnackbar', {
                type: 'error',
                msg: i18n.t('lang_GENERAL_CAPTION_ERROR'),
            })
        } else {
            commit('setSnackbar', {
                type: 'success',
                msg: i18n.t('lang_ACCOUNT_CREDENTIALS_SNACKBAR_CREDENTIAL_SAVED')

            })
            if (getters.getAdminInformationChanged === true) {
                localStorage.clear()
                router.go()
                router.push('/login')
            } else {

                await dispatch('fetchCredentials')
            }

        }
    },
    async deleteAccountCredentials({ commit, getters, dispatch }) {
        let id = getters.getSelectedCredentials
        let response = await api.deleteEntries(DIR, [id])

        if (response === undefined || response.length === 0 || response.error === 1) {
            response = []
            commit('setSnackbar', {
                type: 'error',
                msg: i18n.t('lang_GENERAL_CAPTION_ERROR'),
            })
        } else {
            commit('setSnackbar', {
                type: 'success',
                msg: i18n.t('lang_ACCOUNT_CREDENTIALS_SNACKBAR_CREDENTIAL_DELETED')
            })
            commit('setSelectedCredentials', [])
            commit('setSelectedCredentialsUser', null)
            await dispatch('fetchCredentials')
        }
    },
    async checkCredentialsConnectionStatus({ commit, dispatch }, row) {
        let id = row.id
        let response = await api.getCredentialsConnectionStatus(DIR, row.id)

        if (response === undefined || response.length === 0 || response.error === 1) {
            response = []
            commit('setSnackbar', {
                type: 'error',
                msg: i18n.t('lang_ACCOUNT_CREDENTIALS_SNACKBAR_CONNECTION_FAILED'),
            })
        } else {
            commit('setSnackbar', {
                type: 'success',
                msg: i18n.t('lang_ACCOUNT_CREDENTIALS_SNACKBAR_CONNECTION_SUCCESSFUL'),
            })
        }
    },
    async checkSynchronizeContactsStatus({commit,dispatch}, row){
        let id = row.id
        let response = await api.synchronizeContacts(DIR, row.id)
        
        if (response === undefined || response.length === 0 || response.error === 1) {
            response = []
            commit('setSnackbar', {
                type: 'error',
                msg: i18n.t('lang_GENERIC_CAPTION_SYNC_FAILED'),
            })
        } else {
            
            commit('setSnackbar', {
                type: 'success',
                msg: i18n.t('lang_GENERIC_CAPTION_SYNC_SUCCESSFUL'),
            })
            return response.path;
        }
    }
}

export default {
    state, getters, actions, mutations
}